var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessFoodics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375.707,
    height: 392.594,
    viewBox: "0 0 375.707 392.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_2090274_browser_shop_complete_icon",
    transform: "translate(0 -1.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605",
    transform: "translate(0 1.026)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M269.966,314.6c63.91-9.864,107.959-71.358,98.389-137.334S299.22,65.818,235.313,75.7c-24.545,3.727-48.872-8.045-61.8-29.9-18.806-31.066-53.2-48.243-88.47-44.178S19.9,30.267,8.189,64.849s-3.161,73.031,21.977,98.887c18.3,18.769,22.981,47.821,9.39,70.431-28.19,47.137-15.865,108.792,28.1,140.556s104.295,22.606,137.54-20.879A100.32,100.32,0,0,1,269.966,314.6Z",
    transform: "translate(6.045 -1.026)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M79,124.361H25V81H79v43.361Z",
    transform: "translate(50.003 166.699)",
    fill: "#ced8ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M81,129.556H27a3.05,3.05,0,0,1-3-3.1V83.1A3.05,3.05,0,0,1,27,80H81a3.05,3.05,0,0,1,3,3.1v43.361A3.05,3.05,0,0,1,81,129.556Zm-51-6.194H78V86.194H30Z",
    transform: "translate(48.003 164.602)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    transform: "translate(78.003 247.699)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_584",
    "data-name": "Rectangle 584",
    width: 48.002,
    height: 12.389,
    fill: "#2b5c8e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M96,100.194H24A3.1,3.1,0,0,1,24,94H96a3.1,3.1,0,0,1,0,6.194Z",
    transform: "translate(42.003 193.963)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M7,25H241.01a6.1,6.1,0,0,1,6,6.194V167.473H1V31.194A6.1,6.1,0,0,1,7,25Z",
    transform: "translate(2 49.254)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M242.01,38.389,2,149.889V26H242.01Z",
    transform: "translate(4 51.351)",
    fill: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601",
    transform: "translate(3 74.254)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M241.01,25H7a6.1,6.1,0,0,0-6,6.194V43.583a6.1,6.1,0,0,1,6-6.194H241.01a6.1,6.1,0,0,1,6,6.194V31.194A6.1,6.1,0,0,0,241.01,25Z",
    transform: "translate(-1 -25)",
    fill: "#1c64ba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M249.011,172.667H3a3.05,3.05,0,0,1-3-3.1V33.292A9.15,9.15,0,0,1,9,24H243.01a9.15,9.15,0,0,1,9,9.292V169.57A3.05,3.05,0,0,1,249.011,172.667ZM6,166.473h240.01V33.292a3.05,3.05,0,0,0-3-3.1H9a3.05,3.05,0,0,0-3,3.1Z",
    transform: "translate(0 47.157)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M242.01,42.292,2,153.792V144.5L242.01,33Z",
    transform: "translate(4 66.032)",
    fill: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M1,71H247.011V89.583a12.2,12.2,0,0,1-12,12.389H13A12.2,12.2,0,0,1,1,89.583Z",
    transform: "translate(2 145.726)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M237.01,107.167H15A15.249,15.249,0,0,1,0,91.681V73.1A3.05,3.05,0,0,1,3,70H249.011a3.05,3.05,0,0,1,3,3.1V91.681a15.249,15.249,0,0,1-15,15.486ZM6,76.194V91.681a9.15,9.15,0,0,0,9,9.292H237.01a9.15,9.15,0,0,0,9-9.292V76.194Z",
    transform: "translate(0 143.629)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585",
    "data-name": "Rectangle 585",
    width: 144.006,
    height: 114.598,
    rx: 1,
    transform: "translate(216.009 9.212)",
    fill: "#5cbeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M75,4H213.006a3.05,3.05,0,0,1,3,3.1V109.306H72V7.1A3.05,3.05,0,0,1,75,4Z",
    transform: "translate(144.009 5.212)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M214.986,4.805A2.949,2.949,0,0,0,213.006,4H75a3.05,3.05,0,0,0-3,3.1V74.927Z",
    transform: "translate(144.009 5.212)",
    fill: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M216.006,15.392V6.1L72,76.717v9.292Z",
    transform: "translate(144.009 9.616)",
    fill: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602",
    transform: "translate(216.009 9.212)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M213.006,4H75a3.05,3.05,0,0,0-3,3.1V19.486a3.05,3.05,0,0,1,3-3.1H213.006a3.05,3.05,0,0,1,3,3.1V7.1A3.05,3.05,0,0,0,213.006,4Z",
    transform: "translate(-72 -4)",
    fill: "#1c64ba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M215.006,123.792H77a6.1,6.1,0,0,1-6-6.194V9.194A6.1,6.1,0,0,1,77,3H215.006a6.1,6.1,0,0,1,6,6.194V117.6A6.1,6.1,0,0,1,215.006,123.792ZM77,9.194V117.6H215.006V9.194Z",
    transform: "translate(142.009 3.115)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M233.007,36H176l-3,3.1H131L128,36H68v9.292a6.1,6.1,0,0,0,6,6.194H227.007a6.1,6.1,0,0,0,6-6.194Z",
    transform: "translate(136.009 72.323)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M229.007,56.681H76a9.15,9.15,0,0,1-9-9.292V38.1A3.05,3.05,0,0,1,70,35h60a2.952,2.952,0,0,1,2.13.9l2.13,2.2h39.512l2.13-2.2A2.953,2.953,0,0,1,178,35h57a3.05,3.05,0,0,1,3,3.1v9.292a9.15,9.15,0,0,1-9,9.292ZM73,41.194v6.194a3.05,3.05,0,0,0,3,3.1H229.007a3.05,3.05,0,0,0,3-3.1V41.194H179.235l-2.13,2.2a2.953,2.953,0,0,1-2.1.9H133a2.952,2.952,0,0,1-2.13-.9l-2.1-2.2Z",
    transform: "translate(134.009 70.226)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586",
    "data-name": "Rectangle 586",
    width: 90.004,
    height: 136.278,
    rx: 2,
    transform: "translate(279.012 185.754)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M179,202.473H101a9.149,9.149,0,0,1-9-9.292V69.292A9.15,9.15,0,0,1,101,60h78a9.15,9.15,0,0,1,9,9.292V193.181a9.15,9.15,0,0,1-9,9.292ZM101,66.194a3.05,3.05,0,0,0-3,3.1V193.181a3.05,3.05,0,0,0,3,3.1h78a3.05,3.05,0,0,0,3-3.1V69.292a3.05,3.05,0,0,0-3-3.1Z",
    transform: "translate(184.012 122.657)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_587",
    "data-name": "Rectangle 587",
    width: 90.004,
    height: 99.111,
    transform: "translate(279.012 198.143)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M183,78.07,93,133.139V65h90Z",
    transform: "translate(186.012 133.143)",
    fill: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M183,77.414,93,132.483v-6.194L183,71.22Z",
    transform: "translate(186.012 146.188)",
    fill: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M111.016,108.788a4.312,4.312,0,0,1-3.18-1.363,4.723,4.723,0,0,1-1.32-3.283,4.319,4.319,0,0,1,0-.9,7.013,7.013,0,0,1,.24-.867,4.739,4.739,0,0,1,1.68-2.106l.78-.434.84-.248a4.409,4.409,0,0,1,4.05,1.27,6.683,6.683,0,0,1,.57.712,3.616,3.616,0,0,1,.66,2.571,4.938,4.938,0,0,1-.33,1.765,4.656,4.656,0,0,1-.99,1.518,4.317,4.317,0,0,1-3,1.363Z",
    transform: "translate(212.998 205.501)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603",
    transform: "translate(279.012 198.143)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_588",
    "data-name": "Rectangle 588",
    width: 90.004,
    height: 12.389,
    fill: "#1c64ba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M185,169.306H95a3.05,3.05,0,0,1-3-3.1V67.1A3.05,3.05,0,0,1,95,64h90a3.05,3.05,0,0,1,3,3.1v99.111A3.05,3.05,0,0,1,185,169.306Zm-87-6.194h84V70.194H98Z",
    transform: "translate(184.012 131.046)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_589",
    "data-name": "Rectangle 589",
    width: 54.002,
    height: 105.306,
    rx: 2,
    transform: "translate(39.002 43.281)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M63,125.5H21a9.149,9.149,0,0,1-9-9.292V23.292A9.15,9.15,0,0,1,21,14H63a9.15,9.15,0,0,1,9,9.292v92.917a9.15,9.15,0,0,1-9,9.292ZM21,20.194a3.05,3.05,0,0,0-3,3.1v92.917a3.05,3.05,0,0,0,3,3.1H63a3.05,3.05,0,0,0,3-3.1V23.292a3.05,3.05,0,0,0-3-3.1Z",
    transform: "translate(24.002 26.184)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_590",
    "data-name": "Rectangle 590",
    width: 54.002,
    height: 68.139,
    transform: "translate(39.002 55.67)",
    fill: "#f5fbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M69,92.334H15a3.05,3.05,0,0,1-3-3.1V21.1A3.05,3.05,0,0,1,15,18H69a3.05,3.05,0,0,1,3,3.1V89.236A3.05,3.05,0,0,1,69,92.334ZM18,86.139H66V24.194H18Z",
    transform: "translate(24.002 34.573)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M13,62.361,67,29.314V19H13Z",
    transform: "translate(26.002 36.67)",
    fill: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M13,63.572,67,30.524V24.33L13,57.377Z",
    transform: "translate(26.002 47.849)",
    fill: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M25.016,52.793a4.551,4.551,0,0,1-1.71-.341,4.854,4.854,0,0,1-1.47-1.022,4.165,4.165,0,0,1-.96-1.518,4.424,4.424,0,0,1-.36-1.765,4.315,4.315,0,0,1,0-.9,4.12,4.12,0,0,1,.27-.867,3.985,3.985,0,0,1,.39-.805,4.728,4.728,0,0,1,1.26-1.3,3.676,3.676,0,0,1,.78-.4,3.784,3.784,0,0,1,.84-.279,4.166,4.166,0,0,1,2.61.279,3.413,3.413,0,0,1,.75.4,4.443,4.443,0,0,1,.69.588,6.677,6.677,0,0,1,.57.712,3.615,3.615,0,0,1,.66,2.571,4.937,4.937,0,0,1-.33,1.765A4.538,4.538,0,0,1,25.016,52.793Z",
    transform: "translate(40.987 88.051)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(39.002 55.67)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_591",
    "data-name": "Rectangle 591",
    width: 54.002,
    height: 12.389,
    fill: "#1c64ba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M69,92.334H15a3.05,3.05,0,0,1-3-3.1V21.1A3.05,3.05,0,0,1,15,18H69a3.05,3.05,0,0,1,3,3.1V89.236A3.05,3.05,0,0,1,69,92.334ZM18,86.139H66V24.194H18Z",
    transform: "translate(24.002 34.573)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M283.011,130.194H25A3.1,3.1,0,0,1,25,124H283.011a3.1,3.1,0,0,1,0,6.194Z",
    transform: "translate(44.003 256.88)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M129,130.194H114A3.1,3.1,0,0,1,114,124h15a3.1,3.1,0,0,1,0,6.194Z",
    transform: "translate(222.014 256.88)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M30,130.194H18A3.1,3.1,0,0,1,18,124H30a3.1,3.1,0,0,1,0,6.194Z",
    transform: "translate(30.002 256.88)",
    fill: "#6d6daa"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_592",
    "data-name": "Rectangle 592",
    width: 228.01,
    height: 223.001,
    transform: "translate(78.003 162.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    transform: "translate(78.003 168.196)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M254.01,55H26v54.418a15.3,15.3,0,0,0,6-4.863,14.722,14.722,0,0,0,24,0,14.721,14.721,0,0,0,24,0,14.722,14.722,0,0,0,24,0,14.722,14.722,0,0,0,24,0,14.722,14.722,0,0,0,24,0,14.722,14.722,0,0,0,24,0,14.722,14.722,0,0,0,24,0,14.721,14.721,0,0,0,24,0,14.722,14.722,0,0,0,24,0,15.307,15.307,0,0,0,6,4.956Z",
    transform: "translate(-26 -55)",
    fill: "#7690a8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M254.01,53.389V78.167H26V53.389A12.2,12.2,0,0,1,38,41H242.009A12.2,12.2,0,0,1,254.01,53.389Z",
    transform: "translate(52.003 83.835)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M242.009,41H38A12.2,12.2,0,0,0,26,53.389v9.292A12.2,12.2,0,0,1,38,50.292H242.009a12.2,12.2,0,0,1,12,12.389V53.389A12.2,12.2,0,0,0,242.009,41Z",
    transform: "translate(52.003 83.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M256.01,306.362H28a3.05,3.05,0,0,1-3-3.1V55.486A15.249,15.249,0,0,1,40,40H244.009a15.249,15.249,0,0,1,15,15.486V303.265A3.05,3.05,0,0,1,256.01,306.362ZM31,300.168H253.01V55.486a9.15,9.15,0,0,0-9-9.292H40a9.15,9.15,0,0,0-9,9.292Z",
    transform: "translate(50.003 81.738)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_593",
    "data-name": "Rectangle 593",
    width: 132.006,
    height: 12.389,
    rx: 2,
    transform: "translate(162.007 137.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M182.006,62.583H62A9.3,9.3,0,0,1,62,44H182.006a9.3,9.3,0,0,1,0,18.583ZM62,50.194a3.1,3.1,0,0,0,0,6.194H182.006a3.1,3.1,0,0,0,0-6.194Z",
    transform: "translate(106.007 90.127)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 6,
    cy: 6.194,
    rx: 6,
    ry: 6.194,
    transform: "translate(90.004 137.224)",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M38,62.583a9.3,9.3,0,1,1,9-9.292,9.15,9.15,0,0,1-9,9.292Zm0-12.389a3.1,3.1,0,1,0,3,3.1A3.05,3.05,0,0,0,38,50.194Z",
    transform: "translate(58.004 90.127)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 6,
    cy: 6.194,
    rx: 6,
    ry: 6.194,
    transform: "translate(114.005 137.224)",
    fill: "#ffc661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M46,62.583a9.3,9.3,0,1,1,9-9.292,9.149,9.149,0,0,1-9,9.292Zm0-12.389a3.1,3.1,0,1,0,3,3.1A3.05,3.05,0,0,0,46,50.194Z",
    transform: "translate(74.005 90.127)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 6,
    cy: 6.194,
    rx: 6,
    ry: 6.194,
    transform: "translate(138.006 137.224)",
    fill: "#b1f1a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M54,62.583a9.3,9.3,0,1,1,9-9.292,9.15,9.15,0,0,1-9,9.292Zm0-12.389a3.1,3.1,0,1,0,3,3.1A3.05,3.05,0,0,0,54,50.194Z",
    transform: "translate(90.006 90.127)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M32,81.583h0A12.2,12.2,0,0,1,20,69.194V63H44v6.194A12.2,12.2,0,0,1,32,81.583Z",
    transform: "translate(40.003 129.974)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M34,86.778A15.249,15.249,0,0,1,19,71.292V65.1A3.05,3.05,0,0,1,22,62H46a3.05,3.05,0,0,1,3,3.1v6.194A15.249,15.249,0,0,1,34,86.778ZM25,68.194v3.1a9,9,0,1,0,18,0v-3.1Z",
    transform: "translate(38.002 127.877)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M40,81.583h0A12.2,12.2,0,0,1,28,69.194V63H52v6.194A12.2,12.2,0,0,1,40,81.583Z",
    transform: "translate(56.004 129.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M42,86.778A15.249,15.249,0,0,1,27,71.292V65.1A3.05,3.05,0,0,1,30,62H54a3.05,3.05,0,0,1,3,3.1v6.194A15.249,15.249,0,0,1,42,86.778ZM33,68.194v3.1a9,9,0,1,0,18,0v-3.1Z",
    transform: "translate(54.003 127.877)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M48,81.583h0A12.2,12.2,0,0,1,36,69.194V63H60v6.194A12.2,12.2,0,0,1,48,81.583Z",
    transform: "translate(72.005 129.974)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M50,86.778A15.249,15.249,0,0,1,35,71.292V65.1A3.05,3.05,0,0,1,38,62H62a3.05,3.05,0,0,1,3,3.1v6.194A15.249,15.249,0,0,1,50,86.778ZM41,68.194v3.1a9,9,0,1,0,18,0v-3.1Z",
    transform: "translate(70.005 127.877)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M56,81.583h0A12.2,12.2,0,0,1,44,69.194V63H68v6.194A12.2,12.2,0,0,1,56,81.583Z",
    transform: "translate(88.006 129.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M58,86.778A15.249,15.249,0,0,1,43,71.292V65.1A3.05,3.05,0,0,1,46,62H70a3.05,3.05,0,0,1,3,3.1v6.194A15.249,15.249,0,0,1,58,86.778ZM49,68.194v3.1a9,9,0,1,0,18,0v-3.1Z",
    transform: "translate(86.006 127.877)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M64,81.583h0A12.2,12.2,0,0,1,52,69.194V63H76v6.194A12.2,12.2,0,0,1,64,81.583Z",
    transform: "translate(104.007 129.974)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M66,86.778A15.249,15.249,0,0,1,51,71.292V65.1A3.05,3.05,0,0,1,54,62H78a3.05,3.05,0,0,1,3,3.1v6.194A15.249,15.249,0,0,1,66,86.778ZM57,68.194v3.1a9,9,0,1,0,18,0v-3.1Z",
    transform: "translate(102.007 127.877)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M80,81.583h0A12.2,12.2,0,0,1,68,69.194V63H92v6.194A12.2,12.2,0,0,1,80,81.583Z",
    transform: "translate(136.009 129.974)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M82,86.778A15.249,15.249,0,0,1,67,71.292V65.1A3.05,3.05,0,0,1,70,62H94a3.05,3.05,0,0,1,3,3.1v6.194A15.249,15.249,0,0,1,82,86.778ZM73,68.194v3.1a9,9,0,1,0,18,0v-3.1Z",
    transform: "translate(134.009 127.877)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M88,81.583h0A12.2,12.2,0,0,1,76,69.194V63h24v6.194A12.2,12.2,0,0,1,88,81.583Z",
    transform: "translate(152.01 129.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M90,86.778A15.249,15.249,0,0,1,75,71.292V65.1A3.05,3.05,0,0,1,78,62h24a3.05,3.05,0,0,1,3,3.1v6.194A15.249,15.249,0,0,1,90,86.778ZM81,68.194v3.1a9,9,0,1,0,18,0v-3.1Z",
    transform: "translate(150.01 127.877)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M96,81.583h0A12.2,12.2,0,0,1,84,69.194V63h24v6.194A12.2,12.2,0,0,1,96,81.583Z",
    transform: "translate(168.011 129.974)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M98,86.778A15.249,15.249,0,0,1,83,71.292V65.1A3.05,3.05,0,0,1,86,62h24a3.05,3.05,0,0,1,3,3.1v6.194A15.249,15.249,0,0,1,98,86.778ZM89,68.194v3.1a9,9,0,1,0,18,0v-3.1Z",
    transform: "translate(166.011 127.877)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M104,81.583h0A12.2,12.2,0,0,1,92,69.194V63h24v6.194A12.2,12.2,0,0,1,104,81.583Z",
    transform: "translate(184.012 129.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M106,86.778A15.249,15.249,0,0,1,91,71.292V65.1A3.05,3.05,0,0,1,94,62h24a3.05,3.05,0,0,1,3,3.1v6.194A15.249,15.249,0,0,1,106,86.778ZM97,68.194v3.1a9,9,0,1,0,18,0v-3.1Z",
    transform: "translate(182.012 127.877)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M112,81.583h0a12.2,12.2,0,0,1-12-12.389V63h24v6.194A12.2,12.2,0,0,1,112,81.583Z",
    transform: "translate(200.013 129.974)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M114,86.778A15.249,15.249,0,0,1,99,71.292V65.1a3.05,3.05,0,0,1,3-3.1h24a3.05,3.05,0,0,1,3,3.1v6.194A15.249,15.249,0,0,1,114,86.778Zm-9-18.583v3.1a9,9,0,1,0,18,0v-3.1Z",
    transform: "translate(198.013 127.877)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M44,83.972H20L38,53H56Z",
    transform: "translate(40.003 109.002)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M46,89.167H22A2.985,2.985,0,0,1,19.394,87.6a3.184,3.184,0,0,1,.026-3.113l18-30.972A2.983,2.983,0,0,1,40,52H58a2.975,2.975,0,0,1,2.485,1.358,3.183,3.183,0,0,1,.3,2.886l-12,30.972A3,3,0,0,1,46,89.167ZM27.31,82.972H43.991l9.6-24.778h-12Z",
    transform: "translate(38.003 106.905)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M52,83.972H28L40,53H61Z",
    transform: "translate(56.004 109.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M54,89.169H30a2.975,2.975,0,0,1-2.485-1.358,3.183,3.183,0,0,1-.3-2.886l12-30.972A3,3,0,0,1,42,52H63a2.964,2.964,0,0,1,2.5,1.2A3.177,3.177,0,0,1,66,56L57,86.97A3.009,3.009,0,0,1,54,89.169ZM34.442,82.974H51.783l7.2-24.778h-15Z",
    transform: "translate(54.002 106.903)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M60,83.972H36L45,53H66Z",
    transform: "translate(72.005 109.002)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M62.088,89.169h-24a2.964,2.964,0,0,1-2.5-1.2,3.177,3.177,0,0,1-.5-2.8l9-30.972a3.009,3.009,0,0,1,3-2.2h21a2.962,2.962,0,0,1,2.366,1.114,3.171,3.171,0,0,1,.635,2.6l-6,30.972A3.023,3.023,0,0,1,62.088,89.169ZM42.107,82.974H59.628l4.8-24.778h-15Z",
    transform: "translate(69.918 106.903)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M68,83.972H44L50,53H71Z",
    transform: "translate(88.006 109.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M70.042,89.167h-24a2.962,2.962,0,0,1-2.366-1.114,3.171,3.171,0,0,1-.635-2.6l6-30.972a3.023,3.023,0,0,1,3-2.478h21a2.958,2.958,0,0,1,2.235,1.014,3.161,3.161,0,0,1,.765,2.393l-3,30.972A3.037,3.037,0,0,1,70.042,89.167ZM49.7,82.973H67.342l2.4-24.778H54.5Z",
    transform: "translate(85.965 106.904)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M76,83.972H52L55,53H76Z",
    transform: "translate(104.007 109.002)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M78.011,89.167h-24a2.958,2.958,0,0,1-2.235-1.014,3.161,3.161,0,0,1-.765-2.393l3-30.972a3.037,3.037,0,0,1,3-2.788h21a3.05,3.05,0,0,1,3,3.1V86.07A3.05,3.05,0,0,1,78.011,89.167Zm-20.7-6.194h17.7V58.194H59.71Z",
    transform: "translate(101.997 106.905)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M72,81.583h0A12.2,12.2,0,0,1,60,69.194V63H84v6.194A12.2,12.2,0,0,1,72,81.583Z",
    transform: "translate(120.008 129.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M74,86.778A15.249,15.249,0,0,1,59,71.292V65.1A3.05,3.05,0,0,1,62,62H86a3.05,3.05,0,0,1,3,3.1v6.194A15.249,15.249,0,0,1,74,86.778ZM65,68.194v3.1a9,9,0,1,0,18,0v-3.1Z",
    transform: "translate(118.008 127.877)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_594",
    "data-name": "Rectangle 594",
    width: 24.001,
    height: 30.972,
    transform: "translate(180.008 162.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M86,89.167H62a3.05,3.05,0,0,1-3-3.1V55.1A3.05,3.05,0,0,1,62,52H86a3.05,3.05,0,0,1,3,3.1V86.07A3.05,3.05,0,0,1,86,89.167ZM65,82.972H83V58.194H65Z",
    transform: "translate(118.008 106.905)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M92,83.972H68V53H89Z",
    transform: "translate(136.009 109.002)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M94,89.167H70a3.05,3.05,0,0,1-3-3.1V55.1A3.05,3.05,0,0,1,70,52H91a3.037,3.037,0,0,1,3,2.788L97,85.76a3.162,3.162,0,0,1-.765,2.393A2.958,2.958,0,0,1,94,89.167ZM73,82.972H90.7L88.3,58.194H73Z",
    transform: "translate(134.009 106.905)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M102,83.972H78L75,53H96Z",
    transform: "translate(150.01 109.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M104.011,89.167h-24a3.037,3.037,0,0,1-3-2.788l-3-30.972a3.161,3.161,0,0,1,.765-2.393A2.958,2.958,0,0,1,77.01,52h21a3.023,3.023,0,0,1,3,2.478l6,30.972a3.171,3.171,0,0,1-.635,2.6A2.962,2.962,0,0,1,104.011,89.167Zm-21.3-6.194h17.641l-4.8-24.778H80.31Z",
    transform: "translate(147.999 106.904)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M112,83.972H88L82,53h21Z",
    transform: "translate(164.011 109.002)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M114.042,89.169h-24a3.023,3.023,0,0,1-3-2.478l-6-30.972a3.171,3.171,0,0,1,.635-2.6A2.962,2.962,0,0,1,84.041,52h21a3.009,3.009,0,0,1,3,2.2l9,30.972a3.177,3.177,0,0,1-.5,2.8A2.964,2.964,0,0,1,114.042,89.169ZM92.5,82.974h17.521l-7.2-24.778h-15Z",
    transform: "translate(161.97 106.903)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M122,83.972H98L89,53h21Z",
    transform: "translate(178.011 109.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M124.088,89.169h-24a3.009,3.009,0,0,1-3-2.2L88.087,56a3.177,3.177,0,0,1,.5-2.8,2.964,2.964,0,0,1,2.5-1.2h21a3,3,0,0,1,2.79,1.951l12,30.972a3.183,3.183,0,0,1-.3,2.886A2.975,2.975,0,0,1,124.088,89.169Zm-21.781-6.194h17.341l-9.6-24.778h-15Z",
    transform: "translate(175.925 106.903)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M132,83.972H108L96,53h18Z",
    transform: "translate(192.012 109.002)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M134,89.167H110a3,3,0,0,1-2.79-1.951l-12-30.972a3.183,3.183,0,0,1,.3-2.886A2.975,2.975,0,0,1,98,52h18a2.983,2.983,0,0,1,2.58,1.517l18,30.973a3.184,3.184,0,0,1,.026,3.112A2.985,2.985,0,0,1,134,89.167Zm-21.961-6.194h16.681l-14.4-24.778h-12Z",
    transform: "translate(190.01 106.905)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M60,0c33.139,0,60,27.734,60,61.945s-26.864,61.945-60,61.945S0,96.156,0,61.945,26.864,0,60,0Z",
    transform: "translate(135.006 236.336)",
    fill: "#92f7dd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607",
    transform: "translate(135.006 293.634)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M105,152.8c-31.365-.038-57.41-25.009-59.763-57.3,0,1.549-.24,3.1-.24,4.646,0,34.211,26.864,61.945,60,61.945s60-27.734,60-61.945a29.941,29.941,0,0,0-.24-4.646C162.413,127.789,136.368,152.76,105,152.8Z",
    transform: "translate(-45 -95.5)",
    fill: "#48bc33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608",
    transform: "translate(135.006 236.336)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M105,86.292c31.366.038,57.41,25.009,59.763,57.3,0-1.549.24-3.1.24-4.646,0-34.211-26.864-61.945-60-61.945s-60,27.734-60,61.945a29.941,29.941,0,0,0,.24,4.646C47.592,111.3,73.637,86.33,105,86.292Z",
    transform: "translate(-45 -77)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M107,206.084c-34.8,0-63-29.12-63-65.042S72.207,76,107,76s63,29.12,63,65.042S141.8,206.084,107,206.084Zm0-123.889c-31.482,0-57,26.347-57,58.847s25.521,58.847,57,58.847,57-26.347,57-58.847S138.484,82.194,107,82.194Z",
    transform: "translate(88.006 157.238)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609",
    transform: "translate(166.327 273.792)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M118.533,95.618a7.548,7.548,0,0,0-5.244-6.221,7.237,7.237,0,0,0-7.657,2.35l-27,25.955-11.7-3.283a7.155,7.155,0,0,0-7.543-.457,7.62,7.62,0,0,0-3.948,6.651,7.47,7.47,0,0,0,1.98,5.141l16.741,19.358a8.231,8.231,0,0,0,6,2.447h.48a8.341,8.341,0,0,0,6-3.469l30.481-42.9a7.708,7.708,0,0,0,1.41-5.575Z",
    transform: "translate(-55.44 -89.093)",
    fill: "#48bc33"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M112.974,91.582a4.173,4.173,0,0,0-1.62-2.757h0a4.023,4.023,0,0,0-5.64.774L77.152,117.475l-13.771-4.429c-2.67-1.3-4.05-1.332-5.58.248a4.253,4.253,0,0,0-1.2,3.1,4.142,4.142,0,0,0,1.2,2.571l16.591,19.2a4.959,4.959,0,0,0,3.54,1.487h.36a5.041,5.041,0,0,0,3.51-2.106l30.391-42.866a4.25,4.25,0,0,0,.78-3.1Z",
    transform: "translate(113.206 182.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M79.992,145a7.936,7.936,0,0,1-5.76-2.354L57.491,123.291a7.187,7.187,0,0,1-1.89-4.925,7.292,7.292,0,0,1,3.624-6.472,6.833,6.833,0,0,1,7.236.277l12,3.81,27.151-26.45a6.926,6.926,0,0,1,9.6-1.115,7.3,7.3,0,0,1,2.73,4.832h0a7.392,7.392,0,0,1-1.35,5.42L86.352,141.627a8.034,8.034,0,0,1-6,3.345h-.48ZM62.231,117.127l-.3.279a1.1,1.1,0,0,0-.33.805,1.042,1.042,0,0,0,.24.681l16.741,19.358a1.971,1.971,0,0,0,1.29.465h.24a2,2,0,0,0,1.41-.836l30.241-42.835a1.108,1.108,0,0,0,.24-.836h0a1.072,1.072,0,0,0-1.92-.5l-.27.31L81.252,121.9a2.933,2.933,0,0,1-3,.712l-13.771-4.584h-.39a5.128,5.128,0,0,0-1.86-.774Z",
    transform: "translate(111.206 180.255)",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M65.191,5.873a16.937,16.937,0,0,0,11.04,11.522q8.31,2.849,0,5.73a16.929,16.929,0,0,0-11.07,11.429q-2.76,8.579-5.55,0A16.929,16.929,0,0,0,48.54,23.125q-8.31-2.849,0-5.73A16.931,16.931,0,0,0,59.671,5.873Q62.431-2.613,65.191,5.873Z",
    transform: "translate(88.776 1.267)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M25.231,111.51a11.276,11.276,0,0,0,7.44,7.526q5.55,1.92,0,3.81a11.288,11.288,0,0,0-7.44,7.712q-1.86,5.73-3.69,0a11.286,11.286,0,0,0-7.38-7.619q-5.55-1.92,0-3.81a11.286,11.286,0,0,0,7.38-7.619Q23.431,105.78,25.231,111.51Z",
    transform: "translate(22.771 225.702)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M19.721,95.232a14.092,14.092,0,0,0,9.24,9.539q6.93,2.385,0,4.77a14.092,14.092,0,0,0-9.24,9.539q-2.31,7.155-4.62,0a14.092,14.092,0,0,0-9.24-9.539q-6.93-2.385,0-4.77a14.092,14.092,0,0,0,9.24-9.54Q17.411,88.078,19.721,95.232Z",
    transform: "translate(4.79 190.071)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M122.231,111.5a11.286,11.286,0,0,0,7.38,7.619q5.55,1.92,0,3.81a11.286,11.286,0,0,0-7.38,7.619q-1.86,5.73-3.69,0a11.286,11.286,0,0,0-7.38-7.619q-5.55-1.92,0-3.81a11.286,11.286,0,0,0,7.38-7.619Q120.431,105.8,122.231,111.5Z",
    transform: "translate(216.784 225.713)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M129.231,46.494a11.276,11.276,0,0,0,7.44,7.526q5.55,1.92,0,3.81a11.29,11.29,0,0,0-7.44,7.743q-1.86,5.73-3.69,0a11.286,11.286,0,0,0-7.38-7.619q-5.55-1.92,0-3.81a11.286,11.286,0,0,0,7.38-7.619Q127.461,40.8,129.231,46.494Z",
    transform: "translate(230.785 89.398)",
    fill: "#96d7ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessFoodics);
export default __webpack_public_path__ + "static/media/successFoodics.6a50de43d0cf0b6776523e81e14507d0.svg";
export { ForwardRef as ReactComponent };